import { render, staticRenderFns } from "./ParamCopy.vue?vue&type=template&id=f2be3c8e&scoped=true"
import script from "./ParamCopy.vue?vue&type=script&lang=js"
export * from "./ParamCopy.vue?vue&type=script&lang=js"
import style0 from "./ParamCopy.vue?vue&type=style&index=0&id=f2be3c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2be3c8e",
  null
  
)

export default component.exports